/* eslint-disable @typescript-eslint/no-explicit-any */
// TODO: This file was automatically migrated to TypeScript by `dev typescript migrate`.
//  The eslint disable comment above should be removed and the resulting errors fixed.
import React from 'react';

import {assertAndContinue} from 'Asserts';
import * as DataTableConstants from 'notebook/data-tables/DataTableConstants';
import {DataTableConfig} from 'notebook/data-tables/DataTableConstants';
import * as DataTableUtil from 'notebook/data-tables/DataTableUtil';
import {MODEL_NAMES} from 'results/ResultsNamingConstants';
import {FIELD_TYPES} from 'schemas/fields/SchemaFieldConstants';
import * as ModalContainer from 'ui-library/ModalContainer';

import {configureMapColumnNamesModalPane} from '../panes/MapColumnNamesModalPane';
import ShowErrorsModalPane from '../panes/ShowErrorsModalPane';
import UploadSpreadsheetModalPane from '../panes/UploadSpreadsheetModalPane';
import * as SpreadsheetBulkImportActions from '../SpreadsheetBulkImportActions';
import {
  COLUMN_TYPE,
  COLUMN_TYPE_TO_NAME,
  IMPORT_TYPE,
  Pane,
  PaneKey,
  SPREADSHEET_BULK_IMPORT_KEY,
} from '../SpreadsheetBulkImportConstants';
import SpreadsheetBulkImportModalContainer from '../SpreadsheetBulkImportModalContainer';
import * as SpreadsheetBulkImportUtil from '../SpreadsheetBulkImportUtil';
import {getColumnNamesForImport} from './GetColumnNamesForImport';

interface Props {
  onRequestClose: (...args: Array<any>) => any;
  fileId: string;
  dataTableConfig: DataTableConfig;
  onImportRows: (...args: Array<any>) => any;
}

class BulkAddRowsToDataTableFlow extends React.Component<Props> {
  static open(props: any): void {
    ModalContainer.open(
      SPREADSHEET_BULK_IMPORT_KEY,
      <BulkAddRowsToDataTableFlow {...props} onRequestClose={SpreadsheetBulkImportActions.closeModal} />
    );
  }

  _isStageRunSampleLinkTable = (): boolean => {
    const dataTableConfigType = DataTableUtil.getDataTableConfigType(this.props.dataTableConfig);
    return dataTableConfigType === DataTableConstants.DATA_TABLE_TYPE.STAGE_RUN_SAMPLE_LINK_TABLE;
  };

  _getKeyColumnTypes = (): Array<COLUMN_TYPE> => {
    const keyColumnTypes = [];
    if (this.props.dataTableConfig.linkType === FIELD_TYPES.BATCH_LINK.type) {
      keyColumnTypes.push(COLUMN_TYPE.BATCH_NAME);
    } else if (this.props.dataTableConfig.linkType === FIELD_TYPES.BIOENTITY_LINK.type) {
      keyColumnTypes.push(COLUMN_TYPE.FILENAME);
    }
    if (this._isStageRunSampleLinkTable()) {
      keyColumnTypes.push(COLUMN_TYPE.STAGE_RUN_NAME);
    }
    return keyColumnTypes;
  };

  _getPanes: () => Array<Pane> = () => {
    const isStageRunSampleLinkTable = this._isStageRunSampleLinkTable();
    const keyColumnTypes = this._getKeyColumnTypes();
    return [
      {
        paneKey: PaneKey.UPLOAD_SPREADSHEET,
        configuration: UploadSpreadsheetModalPane.configure({
          getExampleImageURL() {
            return SpreadsheetBulkImportUtil.getExampleImageURLForTagSchema(null);
          },
        }),
      },
      {
        paneKey: PaneKey.MAP_COLUMN_NAMES,
        configuration: configureMapColumnNamesModalPane({
          getValidColumnTypes() {
            if (isStageRunSampleLinkTable) {
              assertAndContinue(
                keyColumnTypes.length > 0,
                `Expected at least one key field if importing into a stage entry ${MODEL_NAMES.result_table}`
              );
            }

            return [...keyColumnTypes, COLUMN_TYPE.DATA_TABLE_VALUE, COLUMN_TYPE.IGNORE];
          },
          getRequiredColumnsError(columns: any) {
            if (keyColumnTypes.includes(COLUMN_TYPE.FILENAME)) {
              const numMatchColumns = columns.filter(({type}: any) => type === COLUMN_TYPE.FILENAME).length;
              if (numMatchColumns === 0) {
                return `At least one "${COLUMN_TYPE_TO_NAME[COLUMN_TYPE.FILENAME]}" field is required.`;
              }
            }
            if (keyColumnTypes.includes(COLUMN_TYPE.BATCH_NAME)) {
              const numMatchColumns = columns.filter(({type}: any) => type === COLUMN_TYPE.BATCH_NAME).length;
              if (numMatchColumns === 0) {
                return `At least one "${COLUMN_TYPE_TO_NAME[COLUMN_TYPE.BATCH_NAME]}" field is required.`;
              }
            }
            const tableColumnNames = columns
              .map(({tableColumnName}: any) => tableColumnName)
              .filter((name: any) => name);
            if (new Set(tableColumnNames).size < tableColumnNames.length) {
              return 'Each column must be selected at most once.';
            }
            return null;
          },
          onValidateSpreadsheet: () => {
            SpreadsheetBulkImportActions.validateNewRowsForDataTableImport(
              this.props.fileId,
              this.props.dataTableConfig
            );
          },
        }),
      },
      {
        paneKey: PaneKey.SHOW_ERRORS,
        configuration: ShowErrorsModalPane.configure({
          enableReplaceLinkWithText: false,
          enableSkipErrors: false,
        }),
      },
    ];
  };

  _handleImportFromSpreadsheet = (): void => {
    SpreadsheetBulkImportActions.getNewRowsForDataTableImport(
      this.props.fileId,
      this.props.dataTableConfig,
      this.props.onImportRows
    );
  };

  render(): JSX.Element {
    return (
      <SpreadsheetBulkImportModalContainer
        importType={IMPORT_TYPE.DATA_TABLE}
        initialSettings={{
          initialTableColumnNames: getColumnNamesForImport(this.props.dataTableConfig),
        }}
        onImportFromSpreadsheet={this._handleImportFromSpreadsheet}
        onRequestClose={this.props.onRequestClose}
        panes={this._getPanes()}
        title={`Import into ${MODEL_NAMES.result_table}`}
      />
    );
  }
}

export default BulkAddRowsToDataTableFlow;
